import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faFire,
  faHandWave,
  faRocket,
  faSparkles,
  faStar,
} from '@fortawesome/pro-duotone-svg-icons'

/**
 * Picks the renter-facing icon for a streak length. Streaks ramp up
 * from a wave to sparkles to a star to fire to a rocket, encouraging the
 * "keep coming back" loop without being too gamified.
 *
 * @param {number} days - the current consecutive-day count
 * @returns {IconDefinition} the icon for that streak length
 */
const streakGlyphFor = (days: number): IconDefinition => {
  if (days >= 30) {
    return faRocket
  }

  if (days >= 14) {
    return faFire
  }

  if (days >= 7) {
    return faStar
  }

  if (days >= 3) {
    return faSparkles
  }

  return faHandWave
}

/**
 * Builds a renter-friendly label for a streak length.
 *
 * @param {number} days - the current consecutive-day count
 * @returns {string} the renter-facing label
 */
const streakLabelFor = (days: number): string => {
  if (days <= 1) {
    return 'Day 1 — welcome back'
  }

  if (days < 7) {
    return `${days}-day streak`
  }

  if (days < 14) {
    return `${days} days in a row`
  }

  if (days < 30) {
    return `${days} days strong`
  }

  return `${days} days · marathoner`
}

export { streakGlyphFor, streakLabelFor }
